import Button from '@/components/basicComponents/button';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { TableColumns } from '@/components/table/types';
import guid from '@/shared/utils/guid';
import { InvestorEntitiesRowStatus } from '../../../investorEntitiesRowStatus';
import { IEntityImportComparison, ImportInvestorEntitiesUpdateMethodOptionEnum, TypeWindow } from '../../../types';

interface MobileTableProps {
  tableColumns: TableColumns[];
  tableData: IEntityImportComparison[];
  updateMethod: ImportInvestorEntitiesUpdateMethodOptionEnum;
  openEntityImportDetailPage: (type: TypeWindow, row: IEntityImportComparison) => void;
}

const MobileTable = ({ tableColumns, tableData, updateMethod, openEntityImportDetailPage }: MobileTableProps) => {
  const TableRow = ({ el }: { el: IEntityImportComparison }) => {
    return (
      <MobileTableRowWrap key={guid()}>
        <MobileRow>
          <MobileRowTitle>{tableColumns[0].title}</MobileRowTitle>
          <MobileRowValue>
            {updateMethod === ImportInvestorEntitiesUpdateMethodOptionEnum.UpdateUsingEntityStaticID ? el?.id : el?.entityCRMId}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{tableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>{el.entityName}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{tableColumns[2].title}</MobileRowTitle>
          <MobileRowValue>{el.householdName}</MobileRowValue>
        </MobileRow>

        {/* <MobileRow>
          <MobileRowTitle>{tableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.fieldsModifiedCount}</MobileRowValue>
        </MobileRow> */}

        <MobileRow>
          <MobileRowTitle>{tableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <InvestorEntitiesRowStatus status={el.status} />
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{tableColumns[4].title}</MobileRowTitle>
          <MobileRowValue>
            {el.status !== 'toDelete' && (
              <Button size="sm" onClick={() => openEntityImportDetailPage('entityImportDetail', el)}>
                View
              </Button>
            )}
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableData.length ? (
        tableData.map((el, index) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;
